var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1254,
    height: 848,
    viewBox: "0 0 1254 848",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_11373)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.941 227.164H877.571V694.248H252.941V227.164Z",
    fill: "#7D8FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.172 217.43H885.873V694.247H243.172V217.43Z",
    stroke: "white",
    strokeWidth: 18.4836,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.603H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_11373)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.539 694.247H1118.54",
    stroke: "white",
    strokeWidth: 27.7254,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.602H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_75_11373)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1114.57 229.513L744.051 507.214",
    stroke: "#F8EC30",
    strokeWidth: 8.31419,
    strokeLinejoin: "round",
    strokeDasharray: "11.45 11.45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M739.893 494.73L727.41 519.684L754.861 514.703L739.893 494.73Z",
    fill: "#F8EC30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.601H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_75_11373)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M874.012 347.057H901.737V544.215H874.012V347.057Z",
    fill: "#17375E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.6H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_75_11373)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M561.746 535.123H810.783",
    stroke: "white",
    strokeWidth: 8.31419,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.599H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_75_11373)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M575.5 540.449H789.963V687.482H575.5V540.449Z",
    fill: "#F8F7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.598H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_75_11373)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M905.444 319.334L904.391 562.999",
    stroke: "#F8EC30",
    strokeWidth: 12.9408,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.597H0V1192.69Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_75_11373)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M243.664 242.938L243.172 614.054",
    stroke: "#F8EC30",
    strokeWidth: 27.7254,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_75_11373",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -155,
    width: 2927,
    height: 1348
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1192.69H2926.76V-154.596H0V1192.69Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_75_11373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M664.919 514.857L272.273 396.11",
    stroke: "#F8EC30",
    strokeWidth: 8.31419,
    strokeLinejoin: "round",
    strokeDasharray: "12.6 12.6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272.649 409.257L252.379 390.086L279.864 385.368L272.649 409.257Z",
    fill: "#F8EC30"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_11373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1254,
    height: 847.452,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopLg);
export default __webpack_public_path__ + "static/media/desktop-lg.7d6fdb0903306764e36eea9598776f3c.svg";
export { ForwardRef as ReactComponent };